import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../api";


export const getDataBanner = createAsyncThunk("awards/getDataBanner", async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const response = await api.get("/api/Award/headSection");
    return response.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

export const getDatatimeline = createAsyncThunk("awards/getDatatimeline", async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const response = await api.get("/api/Award/awards");
    return response.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

export const getDataBadges = createAsyncThunk("awards/getDataBadges", async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const response = await api.get("/api/Award/awardspartner");
    return response.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});


const initialState = {
  banner: [],
  timeline: [],
  badges: [],
  isLoading: false,
  error: null,
};

export const awardsSlice = createSlice({
  name: "groupOverview",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getDataBanner.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDataBanner.fulfilled, (state, action) => {
        state.isLoading = false;
        state.banner = action.payload;
      })
      .addCase(getDataBanner.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(getDatatimeline.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDatatimeline.fulfilled, (state, action) => {
        state.isLoading = false;
        state.timeline = action.payload;
      })
      .addCase(getDatatimeline.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getDataBadges.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDataBadges.fulfilled, (state, action) => {
        state.isLoading = false;
        state.badges = action.payload;
      })
      .addCase(getDataBadges.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default awardsSlice.reducer;
